import React from 'react';
import { Icon, TYPE_OUTLINE } from '@mds/mds-reactjs-library';
import Outline64Circle from '@mds/mds-icons/icons/svg/outline-64-circle.svg';

const Preview = ({ previewItem, showPreview, setShowPreview, setPreviewLoading, previewloading, objRef }) => {

    const handleDownload = (e, previewItem) => {
        if (previewloading) return;
        e.preventDefault();
        const fileUrl = previewItem.url;
        const filename = previewItem.name;

        try {
            const a = document.createElement('a');
            a.href = fileUrl;
            a.download = filename;
            a.click();
        } catch (error) {
            console.error('Download failed:', error);
            alert('The file could not be downloaded. Please try again later.');
        }
    };

    const isPdf = (previewItem !== undefined && previewItem.name !== undefined) ? String(previewItem.name).toLowerCase().endsWith('.pdf') : false;

    return showPreview ? (
        <div className="preview-wrapper">
            <div className="preview">
                <input
                    type="button"
                    className="close"
                    onClick={e => {
                        if (previewItem.url) {
                            try {
                                URL.revokeObjectURL(previewItem.url);
                            } catch (error) {
                            }
                        }
                        setShowPreview(false);
                        setPreviewLoading(false);
                    }}
                />
                <h1>{previewItem.title}</h1>
                <p>{previewItem.description}</p>
                <div className="doc">
                    {previewloading ? (
                        <div className="loadingWrapper">
                            <Icon fill="#2251FF" type={TYPE_OUTLINE} src={Outline64Circle} />
                        </div>
                    ) : isPdf ? (
                        <object ref={objRef} data={previewItem.url} type="application/pdf" width="100%" height="500px">
                            No Preview
                        </object>
                    ) : (
                        <div>No preview is available for this file type. You can download this file.</div>
                    )}
                </div>
                <div className="buttons">
                    <input
                        type="button"
                        value="Dismiss"
                        className="secondary"
                        onClick={e => {
                            if (previewItem.url) {
                                try {
                                    URL.revokeObjectURL(previewItem.url);
                                } catch (error) {
                                }
                            }
                            setShowPreview(false);
                            setPreviewLoading(false);
                            e.stopPropagation();
                        }}
                    />
                    <input
                        type="button"
                        value="Download"
                        className="primary"
                        onClick={e => handleDownload(e, previewItem)}
                    />
                </div>
            </div>
        </div>
    ) : null;
};

export default Preview;